import Language from '../Language'

export default new Language(
  'Kazakh',
  ['Қаңтар', 'Ақпан', 'Наурыз', 'Сәуір', 'Мамыр', 'Маусым', 'Шілде', 'Тамыз', 'Қыркүйек', 'Қазан', 'Қараша', 'Желтоқсан'],
  ['Қаң', 'Ақп', 'Нау', 'Сәу', 'Мам', 'Мау', 'Шіл', 'Там', 'Қыр', 'Қаз', 'Қар', 'Жел'],
  ['Жк', 'Дй', 'Сй', 'Ср', 'Бй', 'Жм', 'Сн']
)
// eslint-disable-next-line
;



//////////////////
// WEBPACK FOOTER
// ./~/vuejs-datepicker/src/locale/translations/kk.js
// module id = 2920
// module chunks = 1